'use client';

import { createSlice } from '@reduxjs/toolkit';
import { ProductsCollectionsStateType } from '../types';

const initialState = {
} as ProductsCollectionsStateType;


export const productsCollectionsSlice = createSlice({
  name: 'productsCollections',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = productsCollectionsSlice.actions;
export default productsCollectionsSlice.reducer;